// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1031":"41c271bc","1332":"e2ea2e11","1989":"a3a5cc0f","3172":"9b7edba7","7311":"86f19f86"}[chunkId] + ".chunk.css";
};